import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { DeviceMeasurement } from '../../../../../../model/device-measurement';
import { AssetMeasurement } from '../../../../../../model/asset-measurement';
import { Kpi } from '../../../../../../model/kpi';
import { SensorIdentifier } from '../../../../../../model/sensor-identifier';

@Component({
  selector: 'app-synoptics-form-measurement-selector',
  templateUrl: './synoptics-form-measurement-selector.component.html',
  styleUrls: ['./synoptics-form-measurement-selector.component.scss']
})
export class SynopticsFormMeasurementSelectorComponent implements OnInit {

  @Input() deviceMeasurements: DeviceMeasurement[];
  @Input() assetMeasurements: AssetMeasurement[];
  @Input() kpis: Kpi[];
  @Output() selectionChange: EventEmitter<SensorIdentifier>

  public selectedSensorTypeOption: string;
  public sensorTypeOptions: SelectItem[];

  public deviceMeasurementsFirst: number;
  public deviceMeasurementsRows: number;
  public assetMeasurementsFirst: number;
  public assetMeasurementsRows: number;
  public kpisFirst: number;
  public kpisRows: number;

  constructor() {
    this.selectionChange = new EventEmitter<SensorIdentifier>();
    this.sensorTypeOptions = [
      { label: 'model.deviceMeasurement', value: 'deviceMeasurement' },
      { label: 'model.assetMeasurement', value: 'assetMeasurement' },
      { label: 'model.kpi', value: 'kpi' }
    ];
    this.selectedSensorTypeOption = this.sensorTypeOptions[0].value;
    this.deviceMeasurementsRows = 5;
    this.assetMeasurementsRows = 5;
    this.kpisRows = 5;
    this.deviceMeasurementsFirst = 0;
    this.assetMeasurementsFirst = 0;
    this.kpisFirst = 0;
  }

  ngOnInit(): void {
  }

  public deviceMeasurementToSensorIdentifier(deviceMeasurement: DeviceMeasurement): SensorIdentifier {
    return { entityType: 'deviceMeasurement', entityUuid: deviceMeasurement.device.uuid, sensorUuid: deviceMeasurement.uuid };
  }

  public assetMeasurementToSensorIdentifier(assetMeasurement: AssetMeasurement): SensorIdentifier {
    return { entityType: 'assetMeasurement', entityUuid: assetMeasurement.asset.uuid, sensorUuid: assetMeasurement.uuid };
  }

  public kpiToSensorIdentifier(kpi: Kpi): SensorIdentifier {
    return { entityType: 'kpi', entityUuid: kpi.uuid, sensorUuid: null };
  }

}
